// @generated by protoc-gen-connect-es v0.10.1 with parameter "target=ts"
// @generated from file src/protos/analysis_management/analysis.admin.apis.proto (package geneo.analysis.admin.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FetchAdminClassReportRequest, FetchAdminClassReportResponse, FetchAdminSchoolReportRequest, FetchAdminSchoolReportResponse, UpdateReportPDFUrlAndStatusRequest, UpdateReportPDFUrlAndStatusResponse } from "./analysis.admin.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.analysis.admin.apis.AdminAnalysisAPIServiceV1
 */
export const AdminAnalysisAPIServiceV1 = {
  typeName: "geneo.analysis.admin.apis.AdminAnalysisAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.analysis.admin.apis.AdminAnalysisAPIServiceV1.fetchAdminClassReport
     */
    fetchAdminClassReport: {
      name: "fetchAdminClassReport",
      I: FetchAdminClassReportRequest,
      O: FetchAdminClassReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.admin.apis.AdminAnalysisAPIServiceV1.updateAdminClassReportPdfRecord
     */
    updateAdminClassReportPdfRecord: {
      name: "updateAdminClassReportPdfRecord",
      I: UpdateReportPDFUrlAndStatusRequest,
      O: UpdateReportPDFUrlAndStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.admin.apis.AdminAnalysisAPIServiceV1.fetchAdminSchoolReport
     */
    fetchAdminSchoolReport: {
      name: "fetchAdminSchoolReport",
      I: FetchAdminSchoolReportRequest,
      O: FetchAdminSchoolReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.admin.apis.AdminAnalysisAPIServiceV1.updateAdminSchoolReportPdfRecord
     */
    updateAdminSchoolReportPdfRecord: {
      name: "updateAdminSchoolReportPdfRecord",
      I: UpdateReportPDFUrlAndStatusRequest,
      O: UpdateReportPDFUrlAndStatusResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

